
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
// eslint-disable-next-line
import { Validation } from 'vuelidate' //Don't remove this import, otherwise validations isnt recognized
import Axios from 'axios'
import {
  FIRSTNAME_FIELD,
  LASTNAME_FIELD,
  EMAIL_FIELD,
  ORGANISATION_FIELD,
  FUNCTION_FIELD,
  CONSENT_FIELD
} from '../helpers/form-constants'
import { getValidations, scrollToElement, setNecessaryFormFields } from '../helpers/functions'
import { IFormField, FormFieldTypes } from '../types/forms'
import { IDownload } from './../store/modules/request-download'
import FormField from './form-field.vue'

@Component({
  validations() {
    return getValidations((this as RequestDownloadForm).formFields)
  },
  components: { FormField }
})
export default class RequestDownloadForm extends Vue {
  formFields: IFormField[] = [
    FIRSTNAME_FIELD,
    LASTNAME_FIELD,
    EMAIL_FIELD,
    { ...ORGANISATION_FIELD, required: true },
    {
      ...FUNCTION_FIELD,
      type: FormFieldTypes.Dropdown,
      options: window.TRANSLATIONS.downloadFormFunctions,
      required: true
    },
    CONSENT_FIELD
  ]

  model: { [key in string]: any } = {}

  loading = false

  isSent = false

  get download(): IDownload | null {
    return this.$store.state.requestDownload.download
  }

  async send(): Promise<void> {
    this.$v.$touch()
    if (this.$v.$invalid) {
      this.$nextTick(() => scrollToElement(this.$el, '.error'))
      return
    }

    this.loading = true

    try {
      const res: { data: { success: boolean; downloadUrl?: string } } = await Axios.post('/sq/assets/requestdownload', {
        ...this.model,
        fileGuid: this.download?.fileGuid,
        fileTitle: this.download?.title,
        extension: this.download?.extension
      })
      if (res.data.success && res.data.downloadUrl) {
        const link = document.createElement('a')
        link.href = res.data.downloadUrl
        link.download = res.data.downloadUrl.substr(res.data.downloadUrl.lastIndexOf('/') + 1)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.isSent = true
      } else throw new Error()
    } catch (error) {
      console.error(error)
      this.$store.commit('notifications/add', { message: this.$options?.filters?.t('downloadFormErrorMessage') })
    } finally {
      this.loading = false
    }
  }

  created(): void {
    setNecessaryFormFields(this, this.formFields)
  }
}
